import { Component } from '@angular/core';
import { Toast, ToastService } from '../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  template: `
    <div class="pointer-events-none fixed bottom-5 right-5 z-[100] flex flex-col items-end gap-2">
      <div
        *ngFor="let toast of toasts$ | async; trackBy: trackById"
        class="pointer-events-auto flex items-center gap-3 rounded-lg px-4 py-3 shadow-lg"
        [class.bg-emerald-600]="toast.type === 'success'"
        [class.bg-red-600]="toast.type === 'error'"
      >
        <lucide-icon
          *ngIf="toast.type === 'success'"
          name="circle-check"
          [size]="15"
          color="white"
          [strokeWidth]="2"
        ></lucide-icon>
        <lucide-icon
          *ngIf="toast.type === 'error'"
          name="triangle-alert"
          [size]="15"
          color="white"
          [strokeWidth]="2"
        ></lucide-icon>
        <span class="text-sm font-medium text-white">{{ toast.message }}</span>
        <button
          (click)="dismiss(toast.id)"
          class="ml-1 text-white/70 transition-colors hover:text-white"
          aria-label="Dismiss"
        >
          <lucide-icon name="x" [size]="13" [strokeWidth]="2"></lucide-icon>
        </button>
      </div>
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toasts$ = this.toast.toasts$;

  constructor(private readonly toast: ToastService) {}

  trackById(_: number, t: Toast): number { return t.id; }

  dismiss(id: number): void { this.toast.dismiss(id); }
}
